export const AvisoLegal = () => {
    return (
        <section className="page-sectionWhite text-white mb-0 text-center">
            {/*<!-- Imagen nosotros-->*/}
            <div className="container px-2">
                <div className="row row-nosotros">
                    {/*<!-- nosotros Descripcion -->*/}
                    <div className="legales">
                        <div>
                            <h4 className="px-2 text-danger text-uppercase text-center">
                                <strong>Aviso Legal</strong>
                            </h4>
                            <h6 className="text-black">OBJETO</h6>
                            <p className="text-black">
                                En cumplimiento del deber de información
                                recogido en el artículo 10 de la Ley 34/2002, de
                                Servicios de la Sociedad de la Información y del
                                Comercio Electrónico,
                                <strong>TRT PRODUCCIONES</strong> S.L.(en
                                adelante, también el “Prestador” o “TRT
                                PRODUCCIONES”), como responsable de la página{" "}
                                <a
                                    href="http://www.trtproducciones.com"
                                    target={"_blank"}
                                    rel={"noreferrer"}
                                >
                                    www.trtproducciones.com
                                </a>{" "}
                                (en adelante, el “Sitio Web), pone a disposición
                                de los usuarios el presente documento que regula
                                el uso del Sitio Web. <br></br>
                            </p>
                            <p className="text-black">
                                Asimismo, se informa a todos los usuarios acerca
                                de las condiciones de acceso y uso del Sitio
                                Web, incluidos sus contenidos y servicios, que
                                deberán ser leídas detenidamente y resultarán de
                                aplicación, junto con otras condiciones
                                particulares que pudieran ser expuestas a los
                                usuarios durante la prestación de los servicios.
                            </p>
                            <ul className="text-black list">
                                <li>
                                    <strong>Titular:</strong>{" "}
                                    <strong>TRT PRODUCCIONES </strong>
                                    S.L.
                                </li>
                                <li>
                                    <strong>N.I.F:</strong> B16946550
                                </li>
                                <li>
                                    <strong>Domicilio Social:</strong> : C/ Río
                                    bergantes 9, 29620, Torremolinos, Málaga.
                                </li>
                                <li>
                                    <strong>Datos registrales:</strong> La
                                    entidad se encuentra debidamente inscrita en
                                    el Registro Mercantil de Málaga al tomo
                                    6078, libro 4985, folio 1, sección 8, hoja
                                    HMA163259, inscripción 1.
                                </li>
                            </ul>
                            <p className="text-black">
                                A continuación, se facilitan las condiciones y
                                términos que regirán el uso y acceso a
                                contenidos y servicios por parte de los
                                usuarios.
                            </p>
                            <h6 className="text-black">
                                CONDICIONES DE ACCESO Y USO DEL SITIO WEB
                            </h6>
                            <p className="text-black">
                                Aquella persona que acceda a esta web tendrá la
                                consideración de usuario (en adelante el
                                “Usuario«), quien acepta, de forma expresa y
                                voluntaria, las disposiciones incluidas en este
                                Aviso Legal y Términos de Uso, así como
                                cualesquiera otras disposiciones legales que
                                fueran de aplicación en su relación con el
                                Prestador. La prestación de los servicios por
                                parte de<strong>TRT PRODUCCIONES</strong> a
                                través del Sitio Web tiene, de forma general,
                                carácter gratuito para los Usuarios. <br></br>El
                                Usuario garantiza la autenticidad de los datos
                                comunicados a través de los canales habilitados
                                en el sitio web, siendo considerado el único
                                responsable de las manifestaciones falsas o
                                inexactas que realice y de los perjuicios que
                                cause al Prestador o a terceros. <br></br>Queda
                                prohibido el uso y la contratación de servicios
                                a través del Sitio Web por menores de edad sin
                                la supervisión de un adulto.
                                <strong>TRT PRODUCCIONES</strong> no será
                                responsable de la utilización indebida del Sitio
                                Web por un menor de edad. <br></br>El uso de los
                                servicios por parte de menores de edad deberá
                                contar con el consentimiento de los padres,
                                tutores o representantes legales, responsables
                                últimos de todos los actos realizados por los
                                menores a su cargo; sin que le pueda ser exigido
                                al Prestador ninguna responsabilidad al
                                respecto.
                                <br></br>
                                El Usuario se compromete a hacer un uso adecuado
                                del Sitio Web y sus contenidos, absteniéndose de
                                utilizar los mismos con finalidades ilícitas o
                                prohibidas, lesivas de derechos o intereses de
                                terceros, o que de cualquier forma puedan dañar,
                                inutilizar, sobrecargar, deteriorar o impedir la
                                normal utilización de equipos informáticos o
                                documentos, archivos y toda clase de contenidos
                                almacenados en cualquier equipo informático del
                                prestador. <br></br>Asimismo, el Usuario se
                                compromete a abstenerse de emplear los
                                contenidos e información de cualquier clase
                                obtenida a través del Sitio Web para remitir
                                cualquier clase de acción de finalidad comercial
                                o de mensajes no solicitados a una pluralidad de
                                personas.
                            </p>
                            <h6 className="text-black">
                                EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD
                            </h6>
                            <p className="text-black">
                                El Prestador se exime de cualquier tipo de
                                responsabilidad derivada de la información
                                publicada en este Sitio Web siempre que la misma
                                haya sido manipulada o introducida por un
                                tercero ajeno.<strong>TRT PRODUCCIONES</strong>
                                únicamente será responsable de los contenidos e
                                información del Sitio Web creada y desarrollada
                                por ella, sin que asuma responsabilidad por
                                contenidos alterados, generados o publicados por
                                terceros o en otras webs que no sean de su
                                titularidad. <br></br>
                                <strong>TRT PRODUCCIONES</strong> no asumirá
                                responsabilidad respecto al contenido o aspectos
                                de terceras páginas web enlazadas mediante
                                links, botones u otro medio disponible en el
                                Sitio Web, cuando éstas gestionadas por terceros
                                ajenos a <strong>TRT PRODUCCIONES</strong>.{" "}
                                <br></br>TRT PRODUCCIONES no garantiza la
                                inexistencia de errores en el acceso al Sitio
                                Web o en su contenido, así como tampoco
                                garantiza su completa actualización, aunque
                                desarrollará sus mejores esfuerzos para, en su
                                caso, evitarlos, subsanarlos, actualizarlos y
                                mantener la mayor calidad posible.<br></br>
                                Asimismo, <strong>TRT PRODUCCIONES</strong> se
                                reserva el derecho a denegar o retirar el acceso
                                a su Web, en cualquier momento y sin necesidad
                                de preaviso, a aquellos Usuarios que incumplan
                                las condiciones aquí establecidas u otras
                                particulares que resulten de aplicación.
                                <br></br> TRT PRODUCCIONES no se hace
                                responsable de los daños y perjuicios que, de
                                cualquier naturaleza, puedan salir a colación de
                                la falta de disponibilidad, mantenimiento y
                                efectivo funcionamiento del Sitio Web o de sus
                                servicios y contenidos; así como tampoco de los
                                posibles errores de seguridad que se puedan
                                producir en el sistema informático del usuario
                                como consecuencia de la presencia de virus en
                                sus dispositivos utilizados para la conexión a
                                los servicios. No obstante,
                                <strong>TRT PRODUCCIONES</strong>
                                advertirá previamente, en la medida de lo
                                posible, de las interrupciones en el
                                funcionamiento del Sitio Web. COOKIES <br></br>{" "}
                                Este Sitio Web puede utilizar cookies (pequeños
                                archivos de información que el servidor envía al
                                ordenador de quien accede en la página) para
                                llevar a cabo determinadas funciones que son
                                consideradas imprescindibles para el correcto
                                funcionamiento de la web, así como para la
                                visualización del contenido ofrecido y
                                prestación de servicios solicitados por el
                                Usuario. En todo caso, para más información,
                                puede acceder a nuestra Política de cookies.
                            </p>
                            <p className="text-black"></p>
                            <p className="text-black"></p>
                            <p className="text-black"></p>
                            <p className="text-black"></p>

                            <h6 className="text-black">
                                PROTECCIÓN DE DATOS PERSONALES
                            </h6>
                            <p className="text-black">
                                <strong>TRT PRODUCCIONES</strong> garantiza la
                                protección de todos los datos de carácter
                                personal que proporcione el Usuario a través de
                                los canales habilitados en el Sitio Web en
                                cumplimiento de lo dispuesto en el Reglamento
                                General de Protección de Datos y la normativa
                                vigente. Para más información acerca del
                                tratamiento de sus datos personales puede
                                acceder a nuestra Política de Privacidad.
                            </p>
                            <h6 className="text-black">
                                PROPIEDAD INTELECTUAL E INDUSTRIAL
                            </h6>
                            <p className="text-black">
                                El Sitio Web, incluyendo a título enunciativo,
                                pero no limitativo la programación, edición,
                                compilación y otros elementos necesarios para su
                                funcionamiento, los diseños, logotipos, textos,
                                marcas, contenidos, fotografías y/o gráficos son
                                propiedad de <strong>TRT PRODUCCIONES</strong>{" "}
                                o, en caso de que fuera necesario, dispone de la
                                licencia o autorización expresa por parte de sus
                                titulares para su explotación. Todos los
                                contenidos del Sitio Web se encuentran
                                debidamente protegidos por la normativa de
                                propiedad intelectual e industrial. <br></br>
                                La reproducción total o parcial, uso,
                                transformación, distribución y/o comunicación
                                pública requieren de la autorización escrita
                                previa por parte de 
                                <strong>TRT PRODUCCIONES</strong>, siendo
                                ilícita su utilización sin autorización previa y
                                sin que el mero uso del Sitio Web implique la
                                cesión de derechos de propiedad intelectual o
                                industrial. <br></br>
                                No obstante, el Usuario podrá hacer uso y
                                obtener copia de los contenidos del Sitio Web
                                únicamente con finalidades de uso personal,
                                educativas y no comerciales o profesionales;
                                debiendo respetar en todo caso lo aquí expuesto
                                y los derechos de propiedad intelectual e
                                industrial de <strong>TRT PRODUCCIONES</strong>
                                . Los usuarios deberán, en estos casos, nombrar
                                la fuente y el autor de los materiales
                                utilizados, incluyendo la URL de 
                                <strong>TRT PRODUCCIONES</strong>. <br></br>
                                <strong>TRT PRODUCCIONES</strong> no se hace
                                responsable del uso que terceros puedan realizar
                                del contenido o imágenes protegidas por derechos
                                de propiedad intelectual. Las vulneraciones e
                                infracciones, por parte de Usuarios o terceros,
                                de los derechos de propiedad intelectual e
                                industrial de <strong>TRT PRODUCCIONES</strong>,
                                podrá dar lugar al ejercicio de las acciones
                                legales correspondientes en cada caso para la
                                correcta salvaguarda de tales derechos.{" "}
                                <br></br>
                                En aquellos casos en que cualquier Usuario o un
                                tercero considere que alguno de los contenidos
                                introducido en nuestra web suponga una violación
                                de sus derechos de propiedad intelectual, deberá
                                enviar una notificación a 
                                <strong>TRT PRODUCCIONES</strong> con indicación
                                completa y precisa de sus datos, indicación de
                                los derechos de propiedad intelectual
                                supuestamente infringidos y su localización en
                                la Web.
                            </p>
                            <h6 className="text-black">
                                MODIFICACIÓN DE LAS CONDICIONES
                            </h6>
                            <p className="text-black">
                                <strong>TRT PRODUCCIONES</strong> se reserva el
                                derecho a modificar, en cualquier momento y sin
                                necesidad de previo aviso, la presentación y
                                configuración del Sitio Web y las presentes
                                condiciones. <br></br>
                                No obstante, se cumplirá el deber de información
                                a los usuarios mediante su publicación en el
                                presente Sitio Web. El Usuario reconoce y acepta
                                que será su responsabilidad revisar
                                periódicamente el presente Aviso Legal ante
                                posibles modificaciones en las Condiciones, de
                                modo que sea conocida la última versión
                                aplicable en cada caso.
                            </p>
                            <h6 className="text-black">
                                LEY APLICABLE Y JURISDICCIÓN
                            </h6>
                            <p className="text-black">
                                La relación entre 
                                <strong>TRT PRODUCCIONES</strong> y el Usuario
                                se regirá por la normativa vigente y las leyes
                                comunes del Derecho de España. <br></br>
                                Para la resolución de las controversias o
                                responsabilidades que puedan desprenderse de la
                                prestación de servicios, las partes acuerdan
                                someterse, con renuncia expresa a cualquier otro
                                fuero, a los Juzgados y Tribunales de la ciudad
                                de Madrid (España). <br></br> <br /> Fecha de
                                actualización: ENERO 2022.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AvisoLegal
